// Debug helper for cart system
export const debugCart = {
  logConfig() {
    if (typeof window !== 'undefined') {
      console.group('🛒 Cart Debug Info');
      console.log('Environment Variables:', {
        domain: process.env.GATSBY_SHOPIFY_STOREFRONT_DOMAIN,
        apiVersion: process.env.GATSBY_SHOPIFY_API_VERSION,
        hasToken: !!process.env.GATSBY_SHOPIFY_STOREFRONT_TOKEN,
        hasSecret: !!process.env.GATSBY_SHOPIFY_SECRET
      });
      console.log('LocalStorage:', {
        lastCartID: localStorage.getItem('lastCartID'),
        virtualCart: localStorage.getItem('virtualCart')
      });
      console.groupEnd();
    }
  },

  logAddToCart(variant, productType, response) {
    if (typeof window !== 'undefined') {
      console.group('🛍️ Add to Cart');
      console.log('Variant:', variant);
      console.log('Product Type:', productType);
      console.log('Response:', response);
      console.groupEnd();
    }
  },

  logCartState(cart) {
    if (typeof window !== 'undefined') {
      console.group('📦 Cart State');
      console.log('Cart:', cart);
      console.log('Total Quantity:', cart?.totalQuantity);
      console.log('Lines:', cart?.lines);
      console.groupEnd();
    }
  },

  logError(message, error) {
    if (typeof window !== 'undefined') {
      console.group('❌ Cart Error');
      console.error(message, error);
      console.error('Stack:', error?.stack);
      console.groupEnd();
    }
  }
};